<template>
<div class="travel2023">
    <div class="top-ornament">
        
    </div>
    <div class="cont">
        <p class="only-pc">你看下每一个宝贝都是萌化父母柔情的小心肝，而TA成长努力的每个瞬间，都是爸爸妈妈人生中最珍贵的记忆~养娃不容易，晒下让你心暖的瞬间，写写你抓狂的日常。</p>
        <div class="main-title">活动主题</div>
        <div class="text main-space">
            带话题  <strong>#晒娃我也会呀#</strong>，发布帖子即成功参与活动。
        </div>
        <div class="main-title">参与方式</div>
        <div class="ps-text">发帖可以参考以下两个方向：</div>
        <div class="text">
           01 <strong>晒照片，记录孩子努力的瞬间：</strong>
           比如努力干饭的小脸、得到的荣誉等…每一个娃都是潜力股！
        </div>
        <div class="text mrg-space">
            02 <strong>分享与孩子有关的小物件：</strong>说说这件东西背后，孩子成长的小故事
        </div>
        <div class="main-title only-pc">活动奖励/评选方式</div>
        <div class="text only-pc">优质奖：10名，每人奖励10加币礼品卡（或等值微信红包）,结合帖子内容的文字图片或视频质量，以及帖子的浏览量、回复量、点赞量，在精选作品中选择10名获奖者。 </div>
        <div class="text only-pc">每日精选参与奖：从每日参与者中精选，可获得5-10元微信红包。</div>
    </div>
    <a href="https://forum.yorkbbs.ca/detail/0a7cacd5-600b-490c-bd19-1353b4480f46?topic=chat" class="paly-detail" target="_blank">活动详情&gt;</a>
</div>
</template>
<script>
export default {
    name:'TravelIntroduction',
    
}
</script>
<style lang="less" scoped>
.travel2023{
    position: relative; z-index: 2;
    &::before{
        position: absolute; left: 10px; top:22px; right: 0 ; bottom: 0; content: ''; z-index: -2; background: #FFD764;  border-radius: 10px 10px 70px 10px;
    }
    &:after{
        position: absolute; left: 0; top: 14px; right: 10px; bottom: 10px; content:''; background: #fff; /* background: url(https://media2.imgyb.xyz/media/v1/image/98e169347f4e6f35d26e1c8e79c36ec3.jpeg) repeat left top; */ z-index: -1; border-radius: 10px 10px 60px 10px;
    }
    .top-ornament{
        position: absolute; z-index: 2; left: 50px; right: 50px; top: 0; height: 33px; background: url(https://media3.imgyb.xyz/media/v1/image/048f1d94aa8d8abd2f612b9e28ce562f.png) repeat-x;
    }
    .cont{
        padding: 58px 50px 50px;
        p{
            font-size: 18px; line-height: 30px; color: #333; margin-bottom: 20px;
        }
        .main-title{font-size: 16px; line-height: 24px; color: #FF8B00; font-weight: bold; margin-bottom: 5px;}
        .text{font-size: 16px; line-height: 26px;
            strong{
                background: linear-gradient(to bottom, #fff 50%,#fff6cd);
            }
        }
        .ps-text{font-size: 14px; line-height: 20px; color: #333; margin-bottom: 5px;}
        .main-space{margin-bottom: 20px;}
        .mrg-space{margin-bottom: 12px;}
    }
    .paly-detail{
        position: absolute; z-index: 2; right: 50px; bottom: 40px; color: #FF8B00; font-size: 16px; line-height: 24px;
    }
}
@media screen and (max-width:768px){
    .travel2023{
        .top-ornament{background-size: 19px 16px; left: 25px; right: 25px;}
        &:before{top: 14px;}
        &:after{top: 6px;}
        .cont{
            padding: 28px 25px 30px;
        }
        .paly-detail{bottom: 20px;}
    }
}
</style>